<template>
  <div class="transaction-story-core">
    <div class="title">{{ title }}</div>
    <div class="transactions">
      <div class="transaction" v-for="t of transactions" :key="t.transactionId">
        <div>{{ t.businessName }}</div>
        <div class="amount">{{ formatAmountWithFractionAndCurrency(t.billingAmount) }}</div>
      </div>
    </div>
    <div class="separator"></div>
    <div class="summary-line">
      <div class="prefix">סה״כ</div>
      <div class="amount">{{ formatAmountWithFractionAndCurrency(selectedSum) }}</div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import TransactionDisplayUtils
  from '@/pages/responsive-pages/authenticated/navigation-pages/cashflow-app/cashflow-view/generic-components/TransactionDisplayUtils';

export default {
  name: 'TransactionStoryCore',
  mixins: [TransactionDisplayUtils],
  props: {
    title: {
      required: true,
      type: String,
    },
    transactions: {
      required: true,
      type: Array,
    },
  },
  computed: {
    selectedSum() {
      return _.sumBy(this.transactions, t => t.billingAmount);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
@import '../../../../../scss/mixins';

.transaction-story-core {
  .title {
    font-weight: bold;
    font-size: 26px;
    margin-bottom: 20px;
  }
  .transactions {
    min-height: 50px;
    .transaction {
      display: flex;
      justify-content: space-between;
      font-size: 12px;
      margin-bottom: 13px;
      .amount {
        flex-shrink: 0;
        width: 50px;
      }
    }
  }
  .separator {
    height: 1px;
    background-color: $riseup_gray_0;
  }
  .summary-line {
    display: flex;
    justify-content: flex-end;
    padding-top: 8px;
    color: $riseup_black;
    font-size: 12px;
    font-weight: bold;
    .prefix {
      padding-left: 8px;
    }
    .amount {
      width: 50px;
    }
  }
}
</style>
